var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00004 6.66082e-06C2.74416 6.66082e-06 2.48801 0.0974753 2.29301 0.292975L0.293006 2.29298C-0.0979941 2.68398 -0.0979941 3.31704 0.293006 3.70704L7.58598 11L0.293006 18.293C-0.0979941 18.684 -0.0979941 19.317 0.293006 19.707L2.29301 21.707C2.68401 22.098 3.31707 22.098 3.70707 21.707L11 14.4141L18.293 21.707C18.683 22.098 19.3171 22.098 19.7071 21.707L21.7071 19.707C22.0981 19.316 22.0981 18.683 21.7071 18.293L14.4141 11L21.7071 3.70704C22.0981 3.31704 22.0981 2.68298 21.7071 2.29298L19.7071 0.292975C19.3161 -0.0980247 18.683 -0.0980247 18.293 0.292975L11 7.58595L3.70707 0.292975C3.51157 0.0974753 3.25591 6.66082e-06 3.00004 6.66082e-06Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/closeX.7484e3c3.svg";
export { ForwardRef as ReactComponent };